import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import {  MenuRequestUpdate ,  MenuType  } from '../../../../models/api-store/menu/menu-request.model';
import { MenuService } from '../../../../services/api-store/menu/menu.service';

import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { UtilsService } from '../../../../services/utils-folder/utils.service';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-header-entity-edit',
  templateUrl: './header-entity-edit.component.html'
})
export class HeaderEntityEditComponent implements OnInit {

  id: number;
  formBuilder: FormGroup;
  request: any = {};
  goBackUrl: string = "/header";
  configCkeditor: any;
  isButtonSaveDisabled: boolean;
  menuItems: any = [];


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private menuService: MenuService,
    private toastr: ToastrService,
    private domSanitizer: DomSanitizer,
    private spinner: SpinnerService,
    private modalService: NgbModal,
    private utilsService: UtilsService
  ) {
    this.id = this.route.snapshot.params['id'];
    this.configCkeditor = this.utilsService.getConfigCkeditor();
    this.initForm();
  }

  ngOnInit(): void {
    this.loadDataByID(this.id);
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }

  loadDataByID(idObj) {
    this.menuService.getEntity(idObj).subscribe(
      (response) => {
        if (response) {
          this.setFormValue(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si ÃƒÂ¨ verificato un errore durante il caricamento delle informazioni del header', 'Load header', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  initForm() {
    this.formBuilder = this.fb.group({
      title: ['', [Validators.required]],
      index: [0, [Validators.required]],
      menuItemsType: ['LINK'],
      externalLink: ['']
    });
  }

  getFormValue() {
    let request = new MenuRequestUpdate();
    request.title = this.formBuilder.controls['title'].value;
    request.index = this.formBuilder.controls['index'].value;
    request.menuItemsType = this.formBuilder.controls['menuItemsType'].value;
    request.externalLink = this.formBuilder.controls['externalLink'].value;
    request.type = MenuType.HEADER;
    return request;
  }

  setFormValue(response) {
    this.formBuilder.controls['title'].setValue(response.title);
    this.formBuilder.controls['index'].setValue(response.index);
    this.formBuilder.controls['menuItemsType'].setValue(response.menuItemsType);
    if (response.externalLink != null) {
      this.formBuilder.controls['externalLink'].setValue(response.externalLink);
    }
    if (response.menuItems != null) {
      this.menuItems = response.menuItems;
    }
  }

  save() {
    this.request = this.getFormValue();
    
    this.menuService.update(this.id, this.request).subscribe(
      (response) => {
        if (response) {
          //Salvato
          this.toastr.success('MenÃƒÂ¹ modificato con successo', 'Modifica menÃƒÂ¹');
          this.isButtonSaveDisabled = true;
          this.activeModal.close(response);
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.isButtonSaveDisabled = true;
        this.toastr.error('Si ÃƒÂ¨ verificato un errore durante la modifica del menÃƒÂ¹', 'Modifica menÃƒÂ¹ fallita', {
          timeOut: 5000
        });
      }
    );
  }

  clickButtonSave() {
    if (this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE) {
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  clickButtonCancel() {
    //Torna indietro alla tabella
    this.router.navigate([this.goBackUrl]);
  }
}
